import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forList = ['Professionals with high mental load who feel like their brain no longer "starts up" the way it used to.', 'Entrepreneurs who need total focus to make high-level decisions.', 'People who "eat healthy" but still feel exhausted with no explanation.', 'Anyone who depends on coffee just to function like a normal human being in the morning.'];
const notForList = ['People looking for a medical diagnosis for chronic illness (this is nutritional optimization).', 'People who are not willing to stay consistent with hydration and daily support.', 'People who think a brightly colored energy drink is the answer to their fatigue.'];
export function WhoItsFor() {
  return <section className="py-24 bg-white px-6 lg:px-8" data-id="element-185">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest/5 p-8 md:p-10 rounded-3xl border border-forest/10" data-id="element-187">
          <h3 className="text-3xl font-bold text-forest mb-8 font-serif" data-id="element-188">
            Who This Is For
          </h3>
          <ul className="space-y-6" data-id="element-189">
            {forList.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-190">
                <div className="mt-1 bg-forest text-white rounded-full p-1 shrink-0" data-id="element-191">
                  <Check size={16} data-id="element-192" />
                </div>
                <span className="text-charcoal/80 leading-relaxed" data-id="element-193">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white p-8 md:p-10 rounded-3xl border border-charcoal/10 shadow-sm" data-id="element-194">
          <h3 className="text-3xl font-bold text-charcoal mb-8 font-serif" data-id="element-195">
            Who This Is Not For
          </h3>
          <ul className="space-y-6" data-id="element-196">
            {notForList.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-197">
                <div className="mt-1 bg-charcoal/10 text-charcoal rounded-full p-1 shrink-0" data-id="element-198">
                  <X size={16} data-id="element-199" />
                </div>
                <span className="text-charcoal/70 leading-relaxed" data-id="element-200">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}